import { useDateRangeCtx } from '../DateRangeContext'
import { DateRangeTabs } from '../DateRangeTabs'
import { OpsHealth } from '../widgets/OpsHealth'

export function OpsSection() {
  const { range } = useDateRangeCtx()
  return (
    <>
      <div className="section-toolbar">
        <DateRangeTabs />
        <div className="muted small">Operations respekterer flow-filteret — Zapier-delivery og validation-rejects vises pr. valgt audience/variant</div>
      </div>
      <OpsHealth range={range} />
    </>
  )
}
